export default __webpack_public_path__ + "images/BD.6d41a60.png";